module.exports = __webpack_public_path__ + "img/trustly.ce0e1ad1.svg";